function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { every, flattenDeep, toPairs } from 'lodash'; // # Internals

/**
 * take a thing:
 * if it is an array, return that array.
 * if it is not an array, put it in an array.
 *
 * @param someThing - the thing to do it to
 * @returns {array}
 */

var ensureIsArray = function ensureIsArray(someThing) {
  return Array.isArray(someThing) ? someThing : [someThing];
};
/**
 * create one function that returns true if all of the provided functions return true
 *
 * @param {array} truthyFunctions
 * @returns {(any) => boolean}
 */


var combineTruthyFunctions = function combineTruthyFunctions(truthyFunctions) {
  return function (value) {
    return every(truthyFunctions, function (func) {
      return func(value);
    });
  };
};
/**
 * combine string values from multiple objects into new object
 *
 * @param {object} previous
 * @param {object} next
 * @returns {object}
 */


export var reduceErrorObjects = function reduceErrorObjects(previous, next) {
  var errors = _objectSpread({}, previous);

  toPairs(next).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (value) {
      errors[key] = errors[key] ? "".concat(errors[key], ", ").concat(value) : value;
    }
  });
  return errors;
};
/*
# Value Validators

Value validators will take a value and return errorMessage or undefined
 */

/**
 * create a single value validator function
 *
 * @param {string} message - error message to display should any of the truthyFunctions fail
 * @param {array} truthyFunctions - functions whose return value truthiness represents the validity of the input value
 * @returns {function}
 */

export var makeValueValidator = function makeValueValidator(message) {
  for (var _len = arguments.length, truthyFunctions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    truthyFunctions[_key - 1] = arguments[_key];
  }

  return function (value) {
    return combineTruthyFunctions(truthyFunctions)(value) ? undefined : message;
  };
};
/**
 * create a single value validator function from a configuration object
 *
 * @param {object} config - configuration object (described below)
 * @param {string} config.errorMessage - error message to display should this fail
 * @param {function|array} config.validator - truthy function or an array of them
 * @returns {function}
 *
 * EXAMPLE CONFIGS:
 *
 *    Single validator:
 *      {
 *          errorMessage: "Must be the word FOO",
 *          validator: (valueUnderTest) => ( valueUnderTest === 'FOO' )
 *      }
 *
 *    Multiple Validators:
 *      {
 *          errorMessage: "Must not be FOO or BAR",
 *          validator: [
 *              (valueUnderTest) => ( valueUnderTest !== 'FOO' ),
 *              (valueUnderTest) => ( valueUnderTest !== 'BAR' )
 *          ]
 *      }
 *
 */

export var makeValueValidatorFromConfig = function makeValueValidatorFromConfig(config) {
  return makeValueValidator.apply(void 0, [config.errorMessage].concat(_toConsumableArray(ensureIsArray(config.validator))));
};
/*
# Object Validators

Object validators will take an object ({key: value})
and return and object ({key: errorMessage or undefined})
 */

/**
 * creates an object validator function from multiple object validator functions
 *
 * @param {...function} validators
 * @returns {function}
 */

export var joinValidators = function joinValidators() {
  for (var _len2 = arguments.length, validators = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    validators[_key2] = arguments[_key2];
  }

  return function (values, props) {
    return validators.map(function (validate) {
      return validate(values, props);
    }).reduce(reduceErrorObjects);
  };
};
/**
 * create an object validator function from a configuration object
 *
 * @param {object} config - configuration object (described below)
 * @param {object|array} config.X - single value validator config object or objects
 * @returns {function}
 *
 * EXAMPLE CONFIGS:
 *
 *    single validator for a property:
 *
 *      {
 *          myFavoriteVariableName: {
 *              validator: (valueUnderTest) => ( valueUnderTest !== 'Foo' ),
 *              errorMessage: 'Foo is better'
 *          }
 *      }
 *
 *    multiple validators for a property:
 *
 *      {
 *          theWorstVariableName: [
 *              {
 *                  validator: (valueUnderTest) => ( valueUnderTest === 'Foo' ),
 *                  errorMessage: 'Foo cannot be the worst variable name.'
 *              },
 *              {
 *                  validator: (valueUnderTest) => ( valueUnderTest === 'Bar' ),
 *                  errorMessage: 'What kind of a monster are you?'
 *              }
 *          ]
 *      }
 */

export var makeValidator = function makeValidator(config) {
  var validators = toPairs(config).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        fieldName = _ref4[0],
        fieldConfig = _ref4[1];

    return ensureIsArray(fieldConfig).map(function (validatorConfig) {
      var validator = makeValueValidatorFromConfig(validatorConfig);
      return function (values) {
        return _defineProperty({}, fieldName, validator(values[fieldName]));
      };
    });
  });
  var flattenedValidators = flattenDeep(validators);
  return joinValidators.apply(void 0, _toConsumableArray(flattenedValidators));
};